<ion-card>
    <ion-card-header>
        <ion-card-title>
            {{faqFolder?.title}}
        </ion-card-title>
    </ion-card-header>
    <ion-card-content>
        <faq-list [faqNodes]="faqFolder?.children" (faqNodeSelected)="selectFaqNode($event)"></faq-list>
    </ion-card-content>
</ion-card>
